import { AttachedFileInfo } from '@/types';
import { getFileIcon } from '@/utils/FileIconsUtils';
import { Box, Text } from '@chakra-ui/react';

interface AttachedFilesListProps {
  files: AttachedFileInfo[];
}

export const AttachedFilesList = ({ files }: AttachedFilesListProps) => {
  if (!files || files.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1.5}>
      {files.map((file, index) => (
        <Box
          key={file.file_id || index}
          display="flex"
          w="fit-content"
          maxW="full"
          alignItems="center"
          gap={2}
          borderRadius="md"
          border="1px solid"
          borderColor="gray.400"
          bg="gray.50"
          px={3}
          py={2}
          transition="colors 0.2s"
          _hover={{ bg: 'gray.100' }}
        >
          <Text
            fontSize="lg"
            color="text.secondary"
            display="flex"
            flexShrink={0}
            alignItems="center"
            justifyContent="center"
          >
            {getFileIcon(file.mimeType)}
          </Text>
          <Box display="flex" minW={0} flex={1} flexDirection="column" gap={0.5}>
            <Text fontSize="sm" fontWeight="medium" truncate color="gray.800">
              {file.filename}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
